export const isRequired = (validators) => {
  return validators?.find((item) => item.type === 'REQUIRED') ? true : false
}

export const getRequiredData = (validators) => {
  return validators?.find((item) => item.type === 'REQUIRED')
}

export const getMaxLengthData = (validators) => {
  return validators?.find((item) => item.type === 'MAXLENGTH') || {}
}

export const getMinLengthData = (validators) => {
  return validators?.find((item) => item.type === 'MINLENGTH') || {}
}

export const getMaxData = (validators) => {
  return validators?.find((item) => item.type === 'MAX') || {}
}

export const getMinData = (validators) => {
  return validators?.find((item) => item.type === 'MINH') || {}
}

export const hasMinValidator = (validators) => {
  return validators?.some((item) => item.type === 'MIN') ?? false
}

// export const getMinValue = (validators) => {
//   const x = validators?.find((item) => item.type === 'MIN')

//   return x.values ?? x.value ?? null
// }

export const isValidators = (validators) => {
  let validate = {}

  if (validators) {
    validators.forEach((item) => {
      switch (item.type) {
        case 'REQUIRED':
          validate['required'] = item.errorMessage
          break
        case 'PATTERN':
          const match = item.value.match(new RegExp('^/(.*?)/([gimy]*)$'))
          const regex = new RegExp(match[1], match[2])
          validate['pattern'] = { value: regex, message: item.errorMessage }
          break
        case 'MAXLENGTH':
          validate['maxLength'] = { value: item.value, message: item.errorMessage }
          break
        case 'MINLENGTH':
          validate['minLength'] = { value: item.value, message: item.errorMessage }
          break
        case 'MAX':
          validate['max'] = { value: item.value, message: item.errorMessage }
          break
        case 'MIN':
          validate['min'] = { value: item.value, message: item.errorMessage }
          break
        case 'EMAIL':
          validate['pattern'] = {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: item.errorMessage,
          }
          break
        default:
          break
      }
    })
  }

  // console.log('validate', validate)

  return validate
}

export const isRequiredFiled = (isRequired, title) => {
  return <label className={isRequired && 'required'}>{title}</label>
}

export const requiredFiled = (validators, text) => {
  return <label className={isRequired(validators) && 'required'}>{text}</label>
}

export const isImage = (type) => {
  return type == 'image/jpeg' || type == 'image/jpg' || type == 'image/png'
}

export const isSupportFileByNameType = (fileName, supportType) => {
  let fileNames = fileName?.split('.')
  let fileType = fileNames?.[fileNames?.length - 1]
  let supportTypeList = supportType?.replaceAll(' ', '').replaceAll('.', '').split(',')

  return supportTypeList?.includes(fileType)
}

export const isSupportFileType = (type, supportType) => {
  console.log('type : ', type)
  let fileType = type?.split('/')?.[1]
  if (fileType == 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
    fileType = 'docx'
  }
  console.log('fileType : ', fileType)
  let supportTypeList = supportType?.replaceAll(' ', '').replaceAll('.', '').split(',')

  return supportTypeList?.includes(fileType)
}

export const isImageOrPdf = (type) => {
  return isImage(type) || type == 'application/pdf'
}

export const isImageOrPdfOrMsFile = (type) => {
  let isCorrect = false
  if (
    type == 'image/jpeg' ||
    type == 'application/pdf' ||
    type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
    type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
    type == 'application/msword'
  ) {
    isCorrect = true
  }

  return isCorrect
}

export const isNewMultiReveiw = (groupId) => {
  return groupId && groupId == 'multi-reveiw' ? true : false
}
export const isValidFileType = (type, validType) => {
  validType = validType.replaceAll('.', '').replaceAll(' ', '')
  var types = type?.split('/')

  if (types?.length > 0) {
    type = types[types.length - 1]
  }

  return validType?.split(',').includes(type)
}
// Extension MIME Type
// .doc      application/msword
// .dot      application/msword

// .docx     application/vnd.openxmlformats-officedocument.wordprocessingml.document
// .dotx     application/vnd.openxmlformats-officedocument.wordprocessingml.template
// .docm     application/vnd.ms-word.document.macroEnabled.12
// .dotm     application/vnd.ms-word.template.macroEnabled.12

// .xls      application/vnd.ms-excel
// .xlt      application/vnd.ms-excel
// .xla      application/vnd.ms-excel

// .xlsx     application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
// .xltx     application/vnd.openxmlformats-officedocument.spreadsheetml.template
// .xlsm     application/vnd.ms-excel.sheet.macroEnabled.12
// .xltm     application/vnd.ms-excel.template.macroEnabled.12
// .xlam     application/vnd.ms-excel.addin.macroEnabled.12
// .xlsb     application/vnd.ms-excel.sheet.binary.macroEnabled.12

// .ppt      application/vnd.ms-powerpoint
// .pot      application/vnd.ms-powerpoint
// .pps      application/vnd.ms-powerpoint
// .ppa      application/vnd.ms-powerpoint

// .pptx     application/vnd.openxmlformats-officedocument.presentationml.presentation
// .potx     application/vnd.openxmlformats-officedocument.presentationml.template
// .ppsx     application/vnd.openxmlformats-officedocument.presentationml.slideshow
// .ppam     application/vnd.ms-powerpoint.addin.macroEnabled.12
// .pptm     application/vnd.ms-powerpoint.presentation.macroEnabled.12
// .potm     application/vnd.ms-powerpoint.template.macroEnabled.12
// .ppsm     application/vnd.ms-powerpoint.slideshow.macroEnabled.12

// .mdb      application/vnd.ms-access
